import { EventEmitter } from '@angular/core';
var FormSwitchComponent = /** @class */ (function () {
    function FormSwitchComponent() {
        this.disabled = false;
        this.placeholder = '';
        this.error = '';
        this.rows = 3;
        this._value = '';
        this.valueEvent = new EventEmitter();
        this.onChange = function () {
        };
        this.onTouched = function () {
        };
    }
    Object.defineProperty(FormSwitchComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (val) {
            this._value = val;
            this.onChange(val);
            this.onTouched();
            this.valueEvent.emit(val);
        },
        enumerable: true,
        configurable: true
    });
    FormSwitchComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    FormSwitchComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    FormSwitchComponent.prototype.writeValue = function (value) {
        if (value) {
            this.value = value;
        }
    };
    FormSwitchComponent.prototype.onBlur = function () {
        this.onTouched();
    };
    return FormSwitchComponent;
}());
export { FormSwitchComponent };



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/inputs/form-switch.component.ts.pre-build-optimizer.js